import MultiLineButton from '../../../components/MultiLineButton'
import { ButtonsBox } from '../../../components/styled'

const GetGuideButtons = ({ openGuide, handleNext }) => {
  return (
    <ButtonsBox maxWidth='none'>
      <MultiLineButton
        variant='tertiaryLight'
        label='Download | view now'
        sublabel='opens new tab'
        onClick={openGuide}
      />
      <MultiLineButton
        label='Logout'
        sublabel='send guide/save email as indicated'
        onClick={handleNext}
      />
    </ButtonsBox>
  )
}

export default GetGuideButtons
